export const symbols = [
  'BTCUSDT',
  'ETHUSDT',
  'BNBUSDT',
]

export default symbols;